import React from 'react';
import PropTypes from 'prop-types';
import { get } from '../../Storage';
import Data from './Data';
import Ticket from './Ticket';
import FilterTicket from './FilterTicket';
import axios from 'axios';
import CircularProgress from 'material-ui/CircularProgress';
import { MGSiteButton } from "mgUiKit";

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'TableTicketListComponent';

var styles = AppSettings.styles;

class TicketList extends React.Component {
    constructor(props, context) {
        super(props);
        var canale = "";
        if(!AppSettings["perms"].terrestrialTicketList){
            canale = "online";
        }
        
        this.state = {
            error: false,
            errorMessage: "",
            data: [],
            configuration: {
                cashoutEnabled: false,
                cashoutProattivoEnabled: false,
                cashoutPollingTimeout: 10000
            },
            showLoading: true,
            opened: false,
            filter: {
                type: "",
                canale: canale
            },
            cashout: null,
            proactiveCashoutList: new Map()        
        }
        this.getData = this.getData.bind(this);
        this.doCashout = this.doCashout.bind(this);
        this.askCashout = this.askCashout.bind(this);
        this.refreshData = this.refreshData.bind(this);
        this.getProactiveCashoutList =  this.getProactiveCashoutList.bind(this);
        this.timeDownloadTicket = Date.now();
        this.pollingInterval = null;
    }

    componentDidMount() {
        this.getData();
    }

    getData(event) {
        if (this.state.opened) {
            this.setState({
                error: false,
                errorMessage: "",
                data: [],
                showLoading: true,
                opened: false
            });
            return;
        }
        this.refreshData();
        //this.startPolling();
    }

    refreshData() {
        this.setState({
            showLoading: true,
            opened: true,
            cashout: null
        });

        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth() + 1;
        let yyyy = today.getFullYear();

        let startDate = dd + "-" + mm + "-" + yyyy;


        let endDate = new Date(today.getTime() - (7 * 24 * 60 * 60 * 1000));

        dd = endDate.getDate();
        mm = endDate.getMonth() + 1;
        yyyy = endDate.getFullYear();
        endDate = dd + "-" + mm + "-" + yyyy;

        var url = AppSettings['env'].urlUserBoxTicketsList.replace('[START_DATE]', startDate).replace('[END_DATE]', endDate);
        axios.get(url)
            .then(({ data, status, statusText }) => {
                var showLoading = false;
                if (data.errors.length == 0) {

                    let configuration = data.configuration;
                    if(configuration == undefined){
                        configuration = {
                            cashoutEnabled: false,
                            cashoutProattivoEnabled: false,
                            cashoutPollingTimeout: 10000
                        }
                    }
                    
                    this.setState({
                        error: false,
                        errorMessage: "",
                        data: data.receipts,
                        configuration: configuration,
                        showLoading: showLoading
                    });
                    if(configuration.cashoutProattivoEnabled){
                        this.getProactiveCashoutList();
                        this.startPolling();
                    }
                    


                } else {
                    this.setState({
                        error: true,
                        errorMessage: "La tua sessione è scaduta",
                        data: [],
                        configuration: {
                            cashoutEnabled: false
                        },
                        showLoading: showLoading,
                        opened: true
                    });
                }
                this.timeDownloadTicket = Date.now() + (1000 * 30);
            })

            .catch( (error) => {
                this.setState({
                    error: true,
                    errorMessage: "",
                    data: [],
                    configuration: {
                        cashoutEnabled: false
                    },
                    showLoading: false,
                    opened: true
                });
            });
    }

    getProactiveCashoutList() {
        //this.setState({ proactiveCashoutList: new Map() });
        if(this.state.data === null || this.state.data.length === 0) {
            return;
        }
        let receipts = this.state.data;
        const ids = receipts
            .filter(receipt => 
                receipt.betId !== 0
            && receipt.isFreebet === false
            && receipt.isProposal === false
            && receipt.isTerrestrial === false
            && receipt.isSystem === false
            && receipt.status === "opened")
            .map(receipt => receipt.betId);
        if(ids.length === 0) {
            return;
        }

        const url = AppSettings['env'].urlUserBoxProactiveCashoutList;
        const bodyData = {
            request: {
                BetIds: ids,
                SessionToken:  "" 
            }
        };

        axios.post(url, bodyData)
            .then(response => {
                const proactiveList = new Map();
                const data = response?.data?.data || [];

                data.forEach(item => {
                    if (Array.isArray(item.errors) && item.errors.length === 0) {
                        proactiveList.set(item.ticketId, item);
                    }
                });

                this.setState({ proactiveCashoutList: proactiveList });
            })
            .catch(error => {
                console.error("Error cashout list:", error);
            });
    }

    componentWillUnmount() {
        this.stopPolling();
    }

    startPolling() {
        if(this.state.configuration.cashoutProattivoEnabled) {
            if (this.pollingInterval) return;

            this.pollingInterval = setInterval(() => {
                this.getProactiveCashoutList();
            }, this.state.configuration.cashoutPollingTimeout); 
        }
    }

    stopPolling() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    }

    renderTabCanale(){
        if(!AppSettings["perms"].terrestrialTicketList
        || this.state.data.length  == 0){
            return;
        }

        // Verifico se ho ticket terrestri
        let dataTe = this.state.data.filter(function(item){
            if(item.isTerrestrial){
                return true;
            }
            else{
                return false;
            }
        });
        
        // Verifico se ho ticket online
        let dataOnline = this.state.data.filter(function(item){
            if(!item.isTerrestrial){
                return true;
            }
            else{
                return false;
            }
        });

        // Verifico se ho proposte
        let dataProp = this.state.data.filter(function(item){
            if(item.isProposal){
                return true;
            }
            else{
                return false;
            }
        });

        var styleOnline = {};
        var styleAgenzia = {};
        var styleProposte = {};
        if(this.state.filter.canale == "online"){
            styleOnline = styles.primaryContrastBackgroundColor;
        }
        if(this.state.filter.canale == "agenzia"){
            styleAgenzia = styles.primaryContrastBackgroundColor;
        }

        if(this.state.filter.canale == "proposte"){
            styleProposte = styles.primaryContrastBackgroundColor;
        }

        //controllo quanti filtri sono attivi 
        let TabCounter = 0;

        var terrestrial = "";
        if (dataTe.length > 0) {
            TabCounter += 1;
            terrestrial = <a style={styleAgenzia} onClick={this.setCanale.bind(this, "agenzia")} href="#">Agenzia</a>;
        }

        var online = "";
        if (dataOnline.length > 0) {
            TabCounter += 1;
            online = <a style={styleOnline} onClick={this.setCanale.bind(this, "online")} href="#">Online</a>;
        }

       var proposal = "";
        if (dataProp.length > 0) {
            TabCounter += 1;
            proposal = <a style={styleProposte} onClick={this.setCanale.bind(this, "proposte")} href="#">Proposte</a>;
        }

    
        if(TabCounter > 1){
            return (
                <div id="bar-tab-canale">
                    {terrestrial}
                    {online}
                    {proposal}
                </div>
            );
        }else{
            return(
                <>
                </>
            );
        }
    }
   
    setCanale(canale){
        var filter = this.state.filter;
        filter.type = "";
        filter.canale = canale;
        this.setState({
            filter: filter,            
        });
    }

    handleFilter(index){
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
        var filter = this.state.filter;

        if (index == "removeFilter") {
            index = "";
            filter.canale = "";
        }
        if (index == "refresh") {
            // Scarico la lista se non sono passati _expireSeconds
            if (Date.now() < this.timeDownloadTicket) {
                return;
            }
            this.refreshData();
            return;
        }
        filter.type = index;
        if( this.state.configuration.cashoutProattivoEnabled && (index ==="opened" || index ==="")) {
            this.getProactiveCashoutList();
            this.startPolling();
        }

        this.setState({
            filter: filter, 
            cashout: null
        }
        );
    }

    renderData() {
        if (this.state.showLoading) {
            return (
                <CircularProgress style={styles.loadingIcon} />
            );
        }

        var counter = {
            opened: 0,
            losing: 0,
            winning: 0,
            total: 0
        };
        counter.total = this.state.data.length;

        // Verifico se ci sono terrestri
        let dataTe = this.state.data.filter(function(item){
            if(item.isTerrestrial){
                return true;
            }
            else{
                return false;
            }
        });
        
        let colCanaleEnabled = false;
        if(dataTe.length > 0 ){
            colCanaleEnabled = true;
        } 
        let ticketContainer = [];

        if (this.state.data.length > 0) {
            let currentData = "";
            let ticketList = [];
            let ticketListProposal = [];
    
            //Verifica Tab proposte Attiva
            let proposalTab = false;
            if(this.state.filter.canale == "" || this.state.filter.canale == "proposte"){
                proposalTab = true;
            }
            //GESTIONE DELLE PROPOSTE
            if(proposalTab){
                this.state.data.map((ticket, index) => {
                    if(ticket.isProposal){

                        //NOTA: non eliminarolo serve per escludere dai filtri l'accettazione
                        var exclude = false;
                        if ((this.state.filter.type == "" || this.state.filter.type == ticket.status)){
                            if(this.state.filter.canale == "agenzia" && !ticket.isTerrestrial){
                                exclude = true;
                            }
                            if(this.state.filter.canale == "online" && ticket.isTerrestrial){
                                exclude = true;
                            }
                        }
                        else {
                            exclude = true;
                        }
                        
                        if(exclude){
                            if(this.state.filter.canale != "" && this.state.filter.type == ""){
                                switch (ticket.status) {
                                    case 'opened':
                                        counter.opened--;
                                        break;
                                    case 'losing':
                                        counter.losing--;
                                        break;
                                    case 'winning':
                                        counter.winning--;
                                        break;
                                }
                            }
                            return null;
                        }

                        ticketListProposal.push(
                            <Ticket 
                                key={ticket.proposalId}
                                colCanaleEnabled ={colCanaleEnabled}
                                ticket={ticket}
                                data={this.state}
                                refreshData={this.refreshData}/>
                        ); 
                    }                                               
                });
      
                if(ticketListProposal.length > 0){
                    let container =       
                      <Data 
                          key ={Math.random()}
                          data={"Accettazione"} 
                          ticketList={ticketListProposal}
                          />;     
  
                          ticketContainer.push(container);
                }        
                
            }
            
            let onlineTerTab = false;
            if(this.state.filter.canale == "" || this.state.filter.canale == "agenzia" || this.state.filter.canale == "online"){
                onlineTerTab = true;
            }

           //GESTIONE TICKET ONLINE - AGENZIA
            if(onlineTerTab){
                this.state.data.map((ticket, index) => {
                        if(!ticket.isProposal){
                            let [data, ora] = ticket.date.split(" ");            
                            switch (ticket.status) {
                                case 'opened':
                                    counter.opened++;
                                    break;
                                case 'losing':
                                    counter.losing++;
                                    break;
                                case 'winning':
                                    counter.winning++;
                                    break; 
                            }
                                                       
                            var exclude = false;
                           // if ((this.state.filter.type == "" || this.state.filter.type == ticket.status)){
                                if(this.state.filter.canale == "agenzia" && !ticket.isTerrestrial){
                                    exclude = true;
                                }
                                if(this.state.filter.canale == "online" && ticket.isTerrestrial){
                                    exclude = true;
                                } 
                           // }
                            // else {
                            //     exclude = true;
                            // }
                            
                            if(exclude){
                                //Nel caso di attivazione tab decremento il contatore ed escludo il ticket 
                                if((this.state.filter.canale != "")){
                                    switch (ticket.status) {
                                        case 'opened':
                                            counter.opened--;
                                            break;
                                        case 'losing':
                                            counter.losing--;
                                            break;
                                        case 'winning':
                                            counter.winning--;
                                            break;
                                    }
                                    return;
                                }
                            }
                            // Attivazione filtro per status 
                            if (this.state.filter.type != "" && this.state.filter.type != ticket.status){
                                return;
                            }
            
                            if(currentData != "" && currentData != data){
                            let container =       
                                <Data 
                                    data={currentData} 
                                    key={currentData}
                                    ticketList={ticketList}
                                    />;     
            
                                    ticketList = [];
                                    ticketContainer.push(container);
            
                            }

                            currentData = data;
                            
                            let dataCashback = undefined;
                            if(this.state.configuration.cashoutProattivoEnabled && this.state.proactiveCashoutList.has(ticket.betId)){
                                dataCashback = this.state.proactiveCashoutList.get(ticket.betId)
                            }

                            ticketList.push(
                                <Ticket
                                    key={ticket.betId}
                                    colCanaleEnabled={colCanaleEnabled}
                                    ticket={ticket}
                                    data={this.state}
                                    refreshData={this.refreshData}
                                    proactiveCashoutData={dataCashback}
                                />
                            );
                        
                            
                        }
                    });

                    if(ticketList.length > 0){
                        let container =       
                        <Data 
                            key ={currentData}
                            data={currentData} 
                            ticketList={ticketList}
                            />;

                            ticketList = [];

                            ticketContainer.push(container);

                    }
            }
            if(ticketContainer.length == 0){
                let noTicket = 
                        <ul className="userBoxBetTicket userBoxBetTicket--noresult">
                            <li key={"no_result"}>Il filtro applicato non ha prodotto risultati</li> 
                        </ul>;
                     ticketContainer.push(noTicket);
            }

        }else{
            let noTicket = 
                    <ul key={"noresult_box"} className="userBoxBetTicket userBoxBetTicket--noresult">
                        <li key={"no_result"}>Il filtro applicato non ha prodotto risultati</li>
                   </ul>;
                     ticketContainer.push(noTicket);
        }

    
        var openTutteLeGiocate = (e) => {
            this.context.openLinkPopup(e, AppSettings.homeRealm + 'betMg/betReport');
        }

        return(
            <div className="mg-user-widget mg-widget-ticket">
                {this.renderTabCanale()}
                <FilterTicket 
                    counter={counter}
                    filter={this.state.filter}  
                    onFilter={this.handleFilter.bind(this)}/> 
                <div className="userBoxTable userBoxBetTicket">
                    {ticketContainer}
                </div>               
                <MGSiteButton
                    title="Tutte le giocate"              
                    class=""
                    label="Tutte le giocate"
                    disabled={false}
                    primary={true}
                    isButton={true}
                    fullWidth={true}
                    actionFunc={openTutteLeGiocate}
                />
            </div>
        );
    }
    
    render() {
        return this.renderData();
    }

   //#region  cashout 
    askCashout(response){
        this.setState({
            cashout: response
        });
    }

    doCashout(response){

        this.setState({
            cashout: response
        });

        // if(response.errors.length == 0){
        //     //this.refreshData();
        // }
        // else{
        //     this.setState({
        //         cashout: response
        //     });
        // }
    }

    getChildContext() {
        return {
            doCashout: this.doCashout,
            askCashout: this.askCashout,
        };
    }

}

TicketList.displayName = componentName;

// PropTypes validation
TicketList.propTypes = {
};

// default props
TicketList.defaultProps = {
};

TicketList.contextTypes = {
    openLinkPopup: PropTypes.func
}

TicketList.childContextTypes = {
    doCashout: PropTypes.func,
    askCashout: PropTypes.func,
}

export default TicketList;